<template>
  <div
    ref="navContainer"
    class="rs-partial-navigation-container"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

/**
 * As a wrapper container for `<RsPartialNavigationTree>` and all its nested goodies,
 * this component helps to determine some initial stylings based on tree props.
 * It applies some stylings only relevant where this component is the root of a navigation section in the app.
 */
export default defineComponent({
  mounted() {
    setTimeout(() => {
      const container = this.$refs.navContainer as Element;
      const hasTileChildren = !!container?.querySelector('.container_variant_tile_with_popout');

      if (hasTileChildren) {
        container.setAttribute('style', 'width:auto');
      }
    });
  },
});
</script>

<style lang="scss">
@import '@/styles/navigation.scss';
</style>
